import { Location } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { Observable, catchError, of, switchMap } from 'rxjs';
import { SchoolAttendanceService } from '../../services/attendance.school.service';
import * as attendanceActions from '../actions/attendance.school.actions';
import { AppState } from '../appstate';

@Injectable()
export class SchoolAttendanceEffects {
  actions$ = inject(Actions);
  store = inject(Store<AppState>);
  attendanceService: SchoolAttendanceService = inject(SchoolAttendanceService);
  toastr: ToastrService = inject(ToastrService);
  private functions: AngularFireFunctions = inject(AngularFireFunctions);
  afs: AngularFirestore = inject(AngularFirestore);
  router: Router = inject(Router);
  location: Location = inject(Location);

  constructor() {}

  // Effect to update a attendance
  update$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(attendanceActions.update),
      switchMap(async ({ groupId, studentId, attendance }) => {
        const _ = await this.attendanceService.update(
          groupId,
          studentId,
          attendance
        );
        return attendanceActions.updateSuccess();
      }),
      catchError((error) => {
        // console.error(`Error updating attendance: ${error}`);
        this.toastr.error(
          `An error occurred, '${error}'. Please try again later.`,
          'Error Updating Attendance'
        );
        return of(attendanceActions.updateFailure({ error }));
      })
    )
  );
}
